module.exports = "https://trybtryb-legacy.web.app/img/overcoming-starter-desktop.71f27f45.webp";